import DashboardView from './DashboardView';

export default DashboardView;
